import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearAuthMessagesAction, loginAction } from '~/store/actions.js';

import { GoogleOAuthProvider } from '@react-oauth/google';
import LoadingSpinner from '~/components/common/LoadingSpinner';
import { notifyError } from '~/components/common/ToastMessages';
import eyeOffIcon from '~/images/eye-off.svg';
import eyeIcon from '~/images/eye.svg';
import FacebookLoginButton from './FacebookLoginButton';
import GoogleLoginButton from './GoogleLoginButton';

const LoginSection = ({ closeLogin = () => {}, pathToRedirect = '/profile' }) => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();

	const [email, setEmail] = useState('');
	const [pass, setPass] = useState('');
	const [visiblePassword, setVisiblePassword] = useState(false);

	const loading = useSelector(state => state.authReducer.loading);
	const successMessage = useSelector(state => state.authReducer.message);
	const authError = useSelector(state => state.authReducer.error);
	const dispatch = useDispatch();

	useEffect(() => {
		if (authError.length > 0) {
			notifyError(authError, () => {
				dispatch(clearAuthMessagesAction());
			});
		}
	});

	useEffect(() => {
		if (successMessage.length > 0) {
			dispatch(clearAuthMessagesAction());
			closeLogin();
			navigate(pathToRedirect);
		}
	}, [successMessage]);

	const handleSubmit = e => {
		e.preventDefault();

		if (email == null || email.length == 0) {
			notifyError(t('complete_all_fields'));
			return;
		}

		if (pass == null || pass.length == 0) {
			notifyError(t('complete_all_fields'));
			return;
		}

		let args = {
			usr: email,
			psw: pass
		};

		dispatch(loginAction(args));
	};

	return (
		<>
			<div id="fb-root"></div>
			<div id="login-wrapper" className="narrow-wrapper">
				<form id="login-form" onSubmit={handleSubmit} method="POST">
					<div className="form-input text-label ">
						<input type="email" name="your-email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="email" />
						<label htmlFor="your-email">Email</label>
						<span className="red">*</span>
					</div>
					<div className="form-input text-label ">
						<input
							type={visiblePassword ? 'text' : 'password'}
							name="your-password"
							required
							value={pass}
							onChange={e => setPass(e.target.value)}
							placeholder="password"
						/>
						<label htmlFor="your-password">Password</label>
						<span className="red">*</span>
						<span id="togglePassVisibillity" className="pass-visibillity-icon" onClick={() => setVisiblePassword(!visiblePassword)}>
							<img src={visiblePassword ? eyeOffIcon : eyeIcon} alt="eye-show-pass" />
						</span>
					</div>

					<div className="forgot-password-link simple-link">
						<a href="/resetpasswordrequest" target="_blank" rel="noreferrer">
							{t('forgot_pass')}
						</a>
					</div>
					<button type="submit" className="submit arrow-button black-arrow-button" disabled={loading}>
						{t('sign_in')}
					</button>
				</form>
			</div>
			<div className="login-alter">
				<span>{t('sign_in_alternative')}</span>
				<div className="flex-col">
					<FacebookLoginButton />
					<GoogleOAuthProvider clientId="761642579817-k66hr9lcgkld5mn81epk5ahi6nsj3acv.apps.googleusercontent.com">
						<GoogleLoginButton />
					</GoogleOAuthProvider>
				</div>
			</div>

			<LoadingSpinner isLoading={loading} />
		</>
	);
};

LoginSection.propTypes = {
	closeLogin: PropTypes.any,
	pathToRedirect: PropTypes.string
};

export default LoginSection;
